<div class="example-box">
  @if (formGroup) {
    <div class="form-group-container">
      <form [formGroup]="formGroup">
        <b class="item-title">Fraud Score</b>
        <mat-form-field class="item-width">
          <mat-select formControlName="minFraudScoreType" class="item-full">
            <mat-option [value]="LimitType.NO_LIMIT">no lower limit</mat-option>
            <mat-option [value]="LimitType.EXCLUSIVE">greater than</mat-option>
            <mat-option [value]="LimitType.INCLUSIVE">greater than or equal to</mat-option>
          </mat-select>
        </mat-form-field>
        @if (formGroup.get('minFraudScoreType').value !== LimitType.NO_LIMIT) {
          <mat-form-field class="input-holder">
            <input formControlName="minFraudScore" placeholder="Lower limit" matInput type="number" />
          </mat-form-field>
        }
        <span class="subitem-title">and</span>
        <mat-form-field class="item-width">
          <mat-select formControlName="maxFraudScoreType" class="item-full">
            <mat-option [value]="LimitType.NO_LIMIT">no upper limit</mat-option>
            <mat-option [value]="LimitType.EXCLUSIVE">lower than</mat-option>
            <mat-option [value]="LimitType.INCLUSIVE">lower than or equal to</mat-option>
          </mat-select>
        </mat-form-field>
        @if (formGroup.get('maxFraudScoreType').value !== LimitType.NO_LIMIT) {
          <mat-form-field class="input-holder">
            <input formControlName="maxFraudScore" placeholder="Upper limit" matInput type="number" />
          </mat-form-field>
        }
        <span class="subitem-title">perform&nbsp;action</span>
        <b>Archive</b>
      </form>
      <div class="action-holder">
        <div>{{ data?.id ? '#' + data.id : 'New one' }}</div>
        @if (!editMode) {
          <button mat-icon-button (click)="startEditing()">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="delete()">
            <mat-icon>delete</mat-icon>
          </button>
        }
        @if (editMode) {
          <button mat-raised-button (click)="save()">Save</button>
          <button mat-icon-button matTooltip="Cancel" (click)="cancel()">
            <mat-icon>close</mat-icon>
          </button>
        }
      </div>
    </div>
  }
</div>
